module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-91.7accbcd8.jpg";